export const publicData = {
  // logo:require("@/assets/img/logo.png"),
  projectName: "支付页面",
  getComArgs:
    process.env.NODE_ENV === "development"
      ? "token=125&udid=125&productId=3635429a-bab7-475c-a236-115058ade7b3&vestId=e62e0364-efce-40fb-8738-aea1add748a1&channel=test3&osType=android&version=1"
      : "",
  // environment:process.env.NODE_ENV === 'development'?true:false,
  list: {
    first: [
      {
        bannerUrl: require("@/assets/img/banner1.png"),
        iconUrl: require("@/assets/img/icon1.png"),
        name: "烈冰传奇-复古元素三职业",
        tag: ["三职业", "复古"],
        desc: "三职业复古刷怪",
        btnDesc: "点击下载",
        downloadUrl:"https://www.pgyer.com/kejinjieduan"
      },
      // {
      //   bannerUrl: require("@/assets/img/banner2.png"),
      //   iconUrl: require("@/assets/img/icon7.jpg"),
      //   name: "烈冰传奇-176合击三职业",
      //   tag: ["合击", "176"],
      //   desc: "英雄合击版本",
      //   btnDesc: "点击下载",
      //   downloadUrl:"https://www.pgyer.com/liebinghj"
      // }
    ],
    second: [
      {
        bannerUrl: require("@/assets/img/banner3.png"),
        iconUrl: require("@/assets/img/icon2.jpg"),
        name: "开局一把刀，装备全靠爆",
        tag: ["单机", "角色扮演"],
        desc: "休闲单机，咔咔爆装备",
        btnDesc: "Taptap下载",
        downloadUrl:"https://l.taptap.cn/O0ap4Jt9?channel=rep-rep_rvejoyknxyw"
      },
      {
        bannerUrl: require("@/assets/img/banner4.png"),
        iconUrl: require("@/assets/img/icon3.jpg"),
        name: "一把刀无限版",
        tag: ["单机", "放置"],
        desc: "轮回中无限刷宝",
        btnDesc: "Taptap下载",
        downloadUrl:"https://l.taptap.cn/ZiNriiL6?channel=rep-rep_aymbvafcj6v"
      },
      {
        bannerUrl: require("@/assets/img/banner5.jpg"),
        iconUrl: require("@/assets/img/icon4.jpg"),
        name: "热血氪金模拟器",
        tag: ["卡牌", "放置"],
        desc: "8L,魂十五大神陪你战斗",
        btnDesc: "Taptap下载",
        downloadUrl:"https://l.taptap.cn/m3OGKyxL?channel=rep-rep_6aozfbjsyn9"
      },
      {
        bannerUrl: require("@/assets/img/banner6.png"),
        iconUrl: require("@/assets/img/icon5.jpg"),
        name: "开局一只小骷髅",
        tag: ["冒险"],
        desc: "单机鬼服小骷髅",
        btnDesc: "Taptap下载",
        downloadUrl:"https://l.taptap.cn/5qrMBtVP?channel=rep-rep_x08bozpmuj8"
      },
      {
        bannerUrl: require("@/assets/img/banner7.png"),
        iconUrl: require("@/assets/img/icon6.jpg"),
        name: "氪金阶段所",
        tag: ["文字", "竖屏"],
        desc: "三职业复古刷怪",
        btnDesc: "Taptap下载",
        downloadUrl:"https://l.taptap.cn/JLuOgBAH?channel=rep-rep_pke2g7pw9rb"
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/utils/publicData.js